// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2k9I3","dragIcon":"SortableItem_dragIcon__1Nm4M","disabled":"SortableItem_disabled__1f9s6"};